"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAttachTypeByAttachId = void 0;
var constants_1 = require("./constants");
var prepareRegExps_1 = require("./prepareRegExps");
var regexps_1 = require("./regexps");
/** Определяет тип аттача исходя из формата его айдишника */
var getAttachTypeByAttachId = function (encodedAttachId, regExps) {
    if (regExps === void 0) { regExps = regexps_1.defaultRegExps; }
    var _a = (0, prepareRegExps_1.prepareRegExps)(regExps).attachesRegExps, cloudAttachIdReg = _a.cloudAttachIdReg, temporaryAttachIdReg = _a.temporaryAttachIdReg, attachIdReg = _a.attachIdReg, cloudStockAttachIdReg = _a.cloudStockAttachIdReg;
    if (!encodedAttachId) {
        return null;
    }
    if (encodedAttachId.match(cloudAttachIdReg)) {
        return constants_1.AttachType.Cloud;
    }
    if (encodedAttachId.match(cloudStockAttachIdReg)) {
        return constants_1.AttachType.CloudStock;
    }
    if (encodedAttachId.match(attachIdReg)) {
        return constants_1.AttachType.Attach;
    }
    if (encodedAttachId.match(temporaryAttachIdReg)) {
        return constants_1.AttachType.Temporary;
    }
    return null;
};
exports.getAttachTypeByAttachId = getAttachTypeByAttachId;
//# sourceMappingURL=getAttachTypeByAttachId.js.map